module.exports = __webpack_public_path__ + "img/18.70ae573d.jpg";